import { createAsyncThunk } from '@reduxjs/toolkit';
import { devicesApi } from 'services/devices/devices.api';
import {
  setLinkingGroupId,
  setSelectedDeviceIndex,
  setUpdatedSelectedDevice,
} from '../slices/deviceSlice';

export const setSelectedDevice = createAsyncThunk(
  'device/setSelectedDevice',
  ({ index, id = -1, queryArg }, { getState, dispatch }) => {
    let deviceIndex = index;
    const state = getState();

    const connectedDevices = devicesApi.endpoints.getConnectedDevices.select(queryArg)(state)?.data;

    if (id >= 0) {
      const foundDeviceIndex = connectedDevices.findIndex((device) => device.id === id); // Find device location in array by ID (returns -1 if not found)

      if (foundDeviceIndex !== -1) {
        deviceIndex = foundDeviceIndex;
      }
    }

    dispatch(setSelectedDeviceIndex(deviceIndex));
    dispatch(setUpdatedSelectedDevice());
    // Explicitly clear group linkage: this thunk dispatches setSelectedDeviceIndex, not
    // setSelectedDeviceId, so the reducer's auto-null on setSelectedDeviceId won't fire here.
    dispatch(setLinkingGroupId(null));
  },
);
